document.addEventListener("DOMContentLoaded", function () {
  const DEBUG = true; // Alternar para false em produção
  const log = (msg, data = "") => {
    if (DEBUG) console.log(`[VideoCarousel] ${msg}`, data);
  };

  const videoCarousel = document.querySelector("[data-js-video-carousel]");

  if (!videoCarousel) return;

  const swiperContainer = videoCarousel.querySelector(".video-carousel-swiper");
  // Variáveis para armazenar referências que serão atualizadas na inicialização
  let vimeoPlayersMap = new Map();
  let isGlobalMuted = true; // Padrão: todos os vídeos começam mudos
  let videos, vimeoIframes, volumeControls;

  // Verificar se o Swiper está disponível de forma robusta
  function startInitialization() {
    log("Iniciando verificação de dependências...");
    if (typeof Swiper === "undefined") {
      log("Swiper não encontrado, tentando novamente em 500ms...");
      setTimeout(startInitialization, 500);
      return;
    }
    log("Swiper detectado. Inicializando em 300ms...");
    setTimeout(initializeVideoCarousel, 300);
  }

  if (videoCarousel.querySelector("iframe[data-vimeo-id]")) {
    const script = document.createElement("script");
    script.src = "https://player.vimeo.com/api/player.js";
    script.onload = startInitialization;
    document.head.appendChild(script);
  } else {
    startInitialization();
  }

  function initializeVideoCarousel() {
    console.group("🚀 [VideoCarousel] Initializing");
    try {
      // Atualizar seletores
      videos = videoCarousel.querySelectorAll("video[data-video-index]");
      vimeoIframes = videoCarousel.querySelectorAll("iframe[data-vimeo-id]");
      volumeControls = videoCarousel.querySelectorAll(
        ".video-carousel__volume-control",
      );

      // Verificar se todos os elementos necessários existem
      if (
        !swiperContainer ||
        (videos.length === 0 && vimeoIframes.length === 0)
      ) {
        return;
      }

      // Inicializar players do Vimeo (evitar duplicados de instância no mesmo elemento)
      if (typeof Vimeo !== "undefined" && vimeoIframes.length > 0) {
        vimeoIframes.forEach((iframe) => {
          try {
            if (!vimeoPlayersMap.has(iframe)) {
              const player = new Vimeo.Player(iframe);
              vimeoPlayersMap.set(iframe, player);
            }
          } catch (e) {
            console.warn("❌ Erro ao inicializar player Vimeo:", e);
          }
        });
        log(`Total de players Vimeo inicializados: ${vimeoPlayersMap.size}`);
      }

      // Contagem de slides reais antes da inicialização
      const currentSlides = swiperContainer.querySelectorAll(".swiper-slide");
      log(`Total de slides encontrados: ${currentSlides.length}`);

      const swiperVideos = new Swiper(swiperContainer, {
        centeredSlides: true,
        loop: true,
        effect: "slide",
        speed: 600,
        watchSlidesProgress: true,
        slideActiveClass: "swiper-slide-active",
        allowTouchMove: true,
        slideToClickedSlide: true,
        slidesPerGroup: 1,
        slidesPerView: 1.6,
        spaceBetween: 10,
        initialSlide: Math.floor(currentSlides.length / 2),

        // Breakpoints responsivos para efeito de "teasing" dos slides laterais
        breakpoints: {
          320: {
            slidesPerView: 1.2,
            spaceBetween: 5,
          },
          768: {
            slidesPerView: 3.4,
            spaceBetween: 10,
          },
          1024: {
            slidesPerView: 5,
            spaceBetween: 10,
          },
        },

        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },

        // Eventos
        on: {
          init: function () {
            log("Swiper inicializado (on.init)");
            handleSlideChangeTransitionEnd(this);
          },
          slideChangeTransitionEnd: function () {
            log("Transição de slide finalizada (on.slideChangeTransitionEnd)");
            handleSlideChangeTransitionEnd(this);
          },
          navigationNext: function () {
            log("Navegação: Próximo slide clicado");
          },
          navigationPrev: function () {
            log("Navegação: Slide anterior clicado");
          },
        },
      });
      swiperContainer.classList.add("is-initialized");

      // Função para lidar com o fim da transição do slide
      function handleSlideChangeTransitionEnd(swiperInstance) {
        console.group("🎬 [VideoCarousel] Slide Change");
        if (
          !swiperInstance ||
          typeof swiperInstance.realIndex === "undefined"
        ) {
          log("Instância do Swiper inválida para transição.");
          console.groupEnd();
          return;
        }

        const activeIndex = swiperInstance.activeIndex;
        const realIndex = swiperInstance.realIndex;
        log(`Active Index: ${activeIndex} | Real Index: ${realIndex}`);

        const activeSlide = swiperInstance.slides[swiperInstance.activeIndex];
        const activeVideoIndex = activeSlide
          ? activeSlide.getAttribute("data-video-index")
          : null;
        const allSlides = swiperInstance.slides;
        log(`Processando status de ${allSlides.length} slides.`);

        // 1. Update Video Playback for all instances (clones)
        allSlides.forEach((slide) => {
          const videoElement = slide.querySelector("video[data-video-index]");
          const vimeoIframe = slide.querySelector("iframe[data-vimeo-id]");

          const slideVideoIndex = slide.getAttribute("data-video-index");
          // Consideramos ativo se o data-video-index bater com o do slide ativo do carrossel
          const isActive =
            slideVideoIndex === activeVideoIndex &&
            slide.classList.contains("swiper-slide-active");

          if (isActive) {
            // Play this instance
            if (videoElement) {
              videoElement.muted = isGlobalMuted;
              videoElement.play().catch((e) => {});
            }
            if (vimeoIframe) {
              let vimeoPlayer = vimeoPlayersMap.get(vimeoIframe);

              // Se o player ainda não existe (ex: clone do Swiper), inicializa agora
              if (!vimeoPlayer && typeof Vimeo !== "undefined") {
                try {
                  vimeoPlayer = new Vimeo.Player(vimeoIframe);
                  vimeoPlayersMap.set(vimeoIframe, vimeoPlayer);
                  log("Novo player Vimeo inicializado sob demanda para clone.");
                } catch (e) {
                  console.warn(
                    "❌ Erro ao inicializar player Vimeo sob demanda:",
                    e,
                  );
                }
              }

              if (vimeoPlayer) {
                if (!isGlobalMuted) {
                  vimeoPlayer
                    .setVolume(1)
                    .then(() => vimeoPlayer.play().catch((e) => {}));
                } else {
                  vimeoPlayer.play().catch((e) => {});
                }
              }
            }
          } else {
            // Pause this instance
            if (videoElement) videoElement.pause();
            if (vimeoIframe) {
              const vimeoPlayer = vimeoPlayersMap.get(vimeoIframe);
              if (vimeoPlayer) vimeoPlayer.pause().catch((e) => {});
            }
          }
        });

        // 2. Update Visual Classes, Height and Stack Order
        allSlides.forEach((slide, index) => {
          const video = slide.querySelector(".video-carousel__video");

          if (index === swiperInstance.activeIndex) {
            slide.classList.add("is-active");
            slide.style.zIndex = "2";
            // Aumento de 20% na escala/altura conforme o snippet do usuário
            slide.style.height = "560px"; // Altura definida no CSS para o ativo
          } else {
            slide.classList.remove("is-active");
            slide.style.zIndex = "1";
            slide.style.height = "480px"; // Altura base
          }
        });

        // 3. Update Volume Controls Visibility
        volumeControls.forEach((control) => {
          const controlIndex = parseInt(
            control.getAttribute("data-video-index"),
          );
          const controlSlide = control.closest(".swiper-slide");

          // Only show control on the slide at the active index
          const isActiveIndex =
            controlSlide &&
            swiperInstance.slides[swiperInstance.activeIndex] === controlSlide;

          if (isActiveIndex && controlIndex === parseInt(activeVideoIndex)) {
            control.style.display = "flex";
            control.innerHTML = isGlobalMuted
              ? `
              <svg viewBox="0 0 24 24">
                <path d="M3 9v6h4l5 5V4L7 9H3zm13.5 3c0-1.77-1.02-3.29-2.5-4.03v8.05c1.48-.73 2.5-2.25 2.5-4.02zM14 3.23v2.06c2.89.86 5 3.54 5 6.71s-2.11 5.85-5 6.71v2.06c4.01-.91 7-4.49 7-8.77s-2.99-7.86-7-8.77z"/>
                <line x1="1" y1="23" x2="23" y2="1" stroke="currentColor" stroke-width="2"/>
              </svg>
            `
              : `
              <svg viewBox="0 0 24 24">
                <path d="M3 9v6h4l5 5V4L7 9H3zm13.5 3c0-1.77-1.02-3.29-2.5-4.03v8.05c1.48-.73 2.5-2.25 2.5-4.02zM14 3.23v2.06c2.89.86 5 3.54 5 6.71s-2.11 5.85-5 6.71v2.06c4.01-.91 7-4.49 7-8.77s-2.99-7.86-7-8.77z"/>
              </svg>
            `;
          } else {
            control.style.display = "none";
          }
        });
        console.groupEnd();
      }

      // Controles de volume
      volumeControls.forEach((control) => {
        const controlIndex = parseInt(control.getAttribute("data-video-index"));
        if (isNaN(controlIndex)) return;

        control.addEventListener("click", function () {
          // Verificar se o ícone atual tem o X (está mudo) ou não (tem som)
          const hasMuteX = control.querySelector("line");
          const isCurrentlyMuted = hasMuteX !== null;

          // Alternar estado global
          isGlobalMuted = !isCurrentlyMuted;

          // Aplicar estado global a TODOS os vídeos Vimeo
          vimeoPlayersMap.forEach((player) => {
            if (player) {
              if (isGlobalMuted) {
                // Mutar todos
                player.setVolume(0).catch(() => {
                  if (typeof player.setMuted === "function") {
                    player.setMuted(true).catch(() => {});
                  }
                });
              } else {
                // Desmutar todos
                player.setVolume(1).catch(() => {
                  if (typeof player.setMuted === "function") {
                    player.setMuted(false).catch(() => {});
                  }
                });
              }
            }
          });

          // Aplicar estado global a TODOS os vídeos HTML5 (incluindo clones dinâmicos)
          const allVideos = videoCarousel.querySelectorAll(
            "video[data-video-index]",
          );
          allVideos.forEach((video) => {
            video.muted = isGlobalMuted;
          });

          // Atualizar TODOS os controles de volume com o novo estado
          volumeControls.forEach((volControl) => {
            const volControlSlide = volControl.closest(".swiper-slide");
            const isActiveVolControl =
              volControlSlide &&
              volControlSlide.classList.contains("swiper-slide-active");

            if (isActiveVolControl) {
              if (isGlobalMuted) {
                // Ícone de mudo (com X)
                volControl.innerHTML = `
                         <svg viewBox="0 0 24 24">
                           <path d="M3 9v6h4l5 5V4L7 9H3zm13.5 3c0-1.77-1.02-3.29-2.5-4.03v8.05c1.48-.73 2.5-2.25 2.5-4.02zM14 3.23v2.06c2.89.86 5 3.54 5 6.71s-2.11 5.85-5 6.71v2.06c4.01-.91 7-4.49 7-8.77s-2.99-7.86-7-8.77z"/>
                           <line x1="1" y1="23" x2="23" y2="1" stroke="currentColor" stroke-width="2"/>
                         </svg>
                       `;
              } else {
                // Ícone de volume (sem X)
                volControl.innerHTML = `
                         <svg viewBox="0 0 24 24">
                           <path d="M3 9v6h4l5 5V4L7 9H3zm13.5 3c0-1.77-1.02-3.29-2.5-4.03v8.05c1.48-.73 2.5-2.25 2.5-4.02zM14 3.23v2.06c2.89.86 5 3.54 5 6.71s-2.11 5.85-5 6.71v2.06c4.01-.91 7-4.49 7-8.77s-2.99-7.86-7-8.77z"/>
                         </svg>
                       `;
              }
            }
          });
        });
      });
    } catch (error) {
      console.error("❌ [VideoCarousel] Erro crítico na inicialização:", error);
    } finally {
      console.groupEnd();
    }
  }

  // Suporte para eventos do Shopify
  document.addEventListener("shopify:section:load", function (event) {
    if (event.target.querySelector("[data-js-video-carousel]")) {
      setTimeout(() => {
        const newVideoCarousel = event.target.querySelector(
          "[data-js-video-carousel]",
        );
        if (newVideoCarousel) {
          initializeVideoCarousel();
        }
      }, 100);
    }
  });
});
